import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export interface ITagsQueryOptions {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	expandTagCategory?: boolean;
	expandTagAlert?: boolean;
	pageSize?: number;
	sortDescriptor?: Api.ISortDescriptor;
	query?: string;
}

export function useTagsQuery({
	sortDescriptor,
	pageSize = 25,
	enabled = true,
	expandTagAlert = false,
	expandTagCategory = false,
	impersonationContext,
	query,
}: ITagsQueryOptions) {
	const userSession = useUserSession();

	let expand: string;

	if (expandTagAlert) {
		expand = 'TagAlert';
	}
	if (expandTagCategory) {
		expand = expand?.length > 0 ? expand + ',Category' : 'Category';
	}

	return useInfiniteQuery({
		enabled,
		queryKey: ['tags', impersonationContext, sortDescriptor, pageSize, query],
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IAccountTag>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'tag',
					queryParams: {
						expand,
						pageSize,
						pageToken: pageParam,
						sort: sortDescriptor?.sort,
						sortBy: sortDescriptor?.sortBy,
						query,
					},
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
	});
}

export function invalidateAllTagFilterQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: ['tags'] });
}
